import { useSwitchr } from '@/lib/switchr/switchr/client';

// https://console.statsig.com/2d7YKn3svx51kl9ppvADhm/experiments/fae-675-e2e-test/setup
export const EXPERIMENT_ID = 'fae-675-e2e-test';

// Shouldn't run in production, used to verify default behavior of experiments
export const ExperimentTestFAE675 = () => {
  const { getExperiment } = useSwitchr();

  const experiment = getExperiment(EXPERIMENT_ID);

  // possible values for 'dataAutomation' from statsig are 'control' + 'test'/'test2'/'test3'/'test4'/'test5'
  // using 'defaultValue' as a way to identify when getting value from Statsig is failing
  const dataAutomation = experiment.get('dataAutomation', 'defaultValue');

  return <span data-automation={`${EXPERIMENT_ID}-${dataAutomation}`} aria-hidden="true" />;
};
